export const COURSE_TYPE = {
  E_LEARNING: 'E-Learning',
}
